import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/store";

export const useStoreReview = () => {
  const parent = useSelector((state: RootState) => state.user.parent);

  useEffect(() => {
    if ("ReactNativeWebView" in window && parent?.login_count > 10) {
      setTimeout(async () => {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            command: "storeReview",
            data: { period: 30 },
          }),
        );
      }, 1000);
    }
  }, [parent?.uid]);
};
